import type { ApiEngagementMessage } from "@bridge-applications/pb-types";
import type { TFunction } from "i18next";
import energySound from "../../assets/static/audio/slot-machine-splash-sound-2.mp3";
import coinSound from "../../assets/static/audio/slot-machine-coins-falling.mp3";
import energyCan from "../../assets/static/images/inbox/energy-can-fat-outlined.png";
import spinWheel from "../../assets/static/images/inbox/spin-wheel-icon.png";
import beachCoins from "../../assets/static/images/holy-wheel/prizes/hw__po__coins.png";
import gram from "../../assets/static/images/coins/style1/coin-style1__gram.webp";
import notcoin from "../../assets/static/images/coins/style1/coin-style1__not.webp";
import usdt from "../../assets/static/images/coins/style1/coin-style1__usdt.webp";
import { CURRENCY_DECIMAL_SCALE } from "./currencyAmount";
import type { RewardCollectionPresentation } from "./rewardCollection";

const CURRENCY_IMAGES: Readonly<Record<string, string>> = {
    BEACH_COINS: beachCoins,
    GRAM: gram,
    NOT: notcoin,
    USDT: usdt,
};

export const INBOX_REWARD_SOUNDS = [energySound, coinSound] as const;

/** One cue for the entire grant. Spins currently share the coin collection cue. */
export function inboxRewardSound(message: ApiEngagementMessage): string {
    return message.rewards.every((reward) => reward.kind === "SM_ENERGY")
        ? energySound
        : coinSound;
}

/** Only present rewards from the confirmed claim response, preserving minor units. */
export function inboxRewardCollection(
    message: ApiEngagementMessage,
    t: TFunction,
): RewardCollectionPresentation | null {
    if (message.rewardState !== "CLAIMED" || message.rewards.length === 0)
        return null;

    return {
        id: message.id,
        rewards: message.rewards.map((reward) => {
            const base = {
                id: reward.key,
                amount: reward.amount,
                decimalScale: 0,
            };
            switch (reward.kind) {
                case "SM_ENERGY":
                    return {
                        ...base,
                        label: t("holyWheel.prizeNames.energy"),
                        imageUrl: energyCan,
                    };
                case "WHEEL_SPINS":
                    return {
                        ...base,
                        label: t("holyWheel.spin"),
                        imageUrl: spinWheel,
                    };
                case "CURRENCY":
                    return {
                        ...base,
                        label:
                            reward.currencyCode === "BEACH_COINS"
                                ? t("holyWheel.prizeNames.beach-coins")
                                : reward.currencyCode,
                        decimalScale:
                            CURRENCY_DECIMAL_SCALE[reward.currencyCode] ?? 0,
                        imageUrl: CURRENCY_IMAGES[reward.currencyCode],
                    };
                default:
                    return { ...base, label: t("holyWheel.prizes.item") };
            }
        }),
    };
}
